<template>
  <el-card body-style="padding:0px 20px" shadow="never">
    <h3 class="common-title mb10">项目辅导<el-button class="ml10" type="text" @click="toEdit">编辑</el-button></h3>
    <div class="card-content">
      <div class="project-detail-content">
        <div
          :class="[hasNotValueFields.includes('职位话术') ? 'warning-text' : '', 'project-detail-content-title mb10']"
        >
          职位话术：
        </div>
        <pre>{{ project.职位话术 || genPositionSpeech(project, company) }}</pre>
      </div>
      <div class="project-detail-content">
        <div
          :class="[hasNotValueFields.includes('职位话术') ? 'warning-text' : '', 'project-detail-content-title mb10']"
        >
          可能的问题及应对（1%<el-tooltip
            class="item"
            style="display:inline;color:#409EFF"
            effect="dark"
            content="业绩贡献率"
            placement="top"
            ><i class="el-icon-question"></i></el-tooltip
          >）：
        </div>
        <!-- <pre>{{ project.可能的问题及应对 || '暂无可能的问题及应对' }}</pre> -->
        <div v-for="(item, index) in project.可能的问题及应对" :key="`projectCoach${index}`" class="flex mb10">
          <pre style="text-indent: 0;">{{`${index+1}、Q：${item.Q}\nA：${item.A}`}}</pre>
        </div>
      </div>
    </div>

    <el-dialog
      :visible.sync="isEditing"
      custom-class="custom-dialog"
      append-to-body
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div slot="title" class="title">
        <div class="title-name">项目辅导</div>
        <div class="side-title"></div>
        <!-- <div class="handle-btn">
          <el-button size="mini" type="text" @click="openHistory('项目基本信息')">操作记录</el-button>
        </div> -->
      </div>
      <div class="card-content">
        <div class="card-content-textarea-item">
          <span :class="[hasNotValueFields.includes('职位话术') ? 'warning-text' : '', 'field-label']">职位话术 </span>
          <el-input
            v-model="projectInEdit.职位话术"
            class="mb15"
            type="textarea"
            :rows="2"
            placeholder="请输入该职位的沟通话术，不填写会显示默认职位话术"
          ></el-input>
        </div>
        <div class="card-content-textarea-item">
          <span :class="[hasNotValueFields.includes('可能的问题及应对') ? 'warning-text' : '', 'field-label']"
            >可能的问题及应对（1%<el-tooltip
              class="item"
              style="display:inline;color:#409EFF"
              effect="dark"
              content="业绩贡献率"
              placement="top"
              ><i class="el-icon-question"></i></el-tooltip
            >） <span class="text-btn ml10" @click="openFindQuestion">从问题题库搜索导入</span>
          </span>
          <!-- <el-input
            v-model="projectInEdit.可能的问题及应对"
            class="mb15"
            type="textarea"
            :rows="2"
            placeholder="请输入该职位可能会存在的问题及应对方法"
          ></el-input> -->
          <div
            v-for="(item, index) in projectInEdit.可能的问题及应对"
            :key="`editProjectCoach${index}`"
            class="flex mb10"
          >
            <span class="mr10" style="align-self:center">{{ index + 1 }}:</span>
            <!-- <el-input
              v-model="projectInEdit.可能的问题及应对[index]"
              class="mr10"
              type="textarea"
              :rows="2"
              placeholder="请输入该职位可能会存在的问题及应对方法"
            ></el-input> -->
            <div class="flex flex-auto flex-wrap flex-column mr10">
              <div class="flex mb10">
                <span class="mt10 mr10">Q:</span>
                <el-input
                  v-model="projectInEdit.可能的问题及应对[index]['Q']"
                  class="mr10"
                  type="textarea"
                  :rows="2"
                  placeholder="请输入该职位可能会存在的问题"
                ></el-input>
              </div>
              <div class="flex">
                <span class="mt10 mr10">A:</span>
                <el-input
                  v-model="projectInEdit.可能的问题及应对[index]['A']"
                  class="mr10"
                  type="textarea"
                  :rows="2"
                  placeholder="请输入对该问题的应答"
                ></el-input>
              </div>
            </div>
            <i class="ft-danger el-icon-delete" style="align-self:center" @click="removeQuestion(index)" />
          </div>
          <div class="flex justify-center">
            <a @click="addQuestion"> <i class="el-icon-circle-plus" />增加一条问题 </a>
          </div>
        </div>
      </div>
      <div slot="footer">
        <el-row type="flex" align="center" justify="center">
          <el-button size="small" type="info" style="margin-right:20px" @click="cancelEdit">取消</el-button>
          <el-button size="small" type="primary" class="custom-primary-plain" @click="confirmEdit">保存</el-button>
        </el-row>
      </div>
    </el-dialog>
    <!-- component -->
    <FindQuestion
      ref="FindQuestion"
      :has-questiones="projectInEdit.可能的问题及应对"
      @addQuestion="componentAddQuestion"
      @removeQuestion="componentRemoveQuestion"
    ></FindQuestion>
  </el-card>
</template>
<script>
import { defaultProject, defaultCompany } from '../../constant/defaultData'
import { genPositionSpeech } from '../../constant/utils'
import mixin from './mixin'
import FindQuestion from '../NewCreateProject/FindQuestion'

export default {
  components: { FindQuestion },
  mixins: [mixin],
  props: {
    project: { type: Object, default: () => window._.cloneDeep(defaultProject) },
    company: { type: Object, default: () => window._.cloneDeep(defaultCompany) },
    hasNotValueFields: { type: Array, default: () => [] },
  },
  data() {
    return {
      componentType: '项目辅导',
      fields: ['职位话术', '可能的问题及应对'],
    }
  },
  computed: {
    genPositionSpeech() {
      return genPositionSpeech
    },
  },
  methods: {
    addQuestion() {
      if (!this.projectInEdit.可能的问题及应对) this.$set(this.projectInEdit, '可能的问题及应对', [])
      this.projectInEdit.可能的问题及应对.push({ Q: '', A: '' })
    },
    removeQuestion(index) {
      this.projectInEdit.可能的问题及应对.splice(index, 1)
    },
    openFindQuestion() {
      this.$refs.FindQuestion.open()
    },
    componentAddQuestion(question) {
      if (!this.projectInEdit.可能的问题及应对[this.projectInEdit.可能的问题及应对.length - 1]) {
        const length = this.projectInEdit.可能的问题及应对.length
        this.projectInEdit.可能的问题及应对.splice(length - 1, 1, question)
      } else this.projectInEdit.可能的问题及应对.push(question)
      this.$message.success('添加成功')
    },
    componentRemoveQuestion(question) {
      this.projectInEdit.可能的问题及应对 = this.projectInEdit.可能的问题及应对.filter(v => v === question)
      this.$message.success('已移除')
    },
  },
}
</script>
<style scoped src="../../css/newProjectDetail.css"></style>
